/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Error_Pdf_Password_ProtectedInputs */

const en_conversion_error_pdf_password_protected = /** @type {(inputs: Conversion_Error_Pdf_Password_ProtectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PDF is password protected.`)
};

const es_conversion_error_pdf_password_protected = /** @type {(inputs: Conversion_Error_Pdf_Password_ProtectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este PDF está protegido con contraseña.`)
};

/**
* | output |
* | --- |
* | "This PDF is password protected." |
*
* @param {Conversion_Error_Pdf_Password_ProtectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_pdf_password_protected = /** @type {((inputs?: Conversion_Error_Pdf_Password_ProtectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Pdf_Password_ProtectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_pdf_password_protected(inputs)
	return en_conversion_error_pdf_password_protected(inputs)
});